import React, { useState } from "react";
import { FunnelIcon } from "@heroicons/react/24/outline";

import { Button } from "src/components/Component";

const SelectFilter = ({ title, onChange, value, fieldTitle, options }) => {
  const [selectedValues, setSelectedValues] = useState(value || []);

  const toggleOption = (optionValue) => {
    setSelectedValues((prev) => {
      if (prev.includes(optionValue)) {
        return prev.filter((v) => v !== optionValue);
      }
      return [...prev, optionValue];
    });
  };

  const submit = () => {
    onChange(selectedValues);
  };

  return (
    <div className='bg-white px-4 py-4 border shadow-md rounded-md overflow-hidden z-50'>
      <div className='text-md font-bold text-violet-800 border-b pb-1 border-violet-800'>{title} Filter</div>
      <div className="flex flex-col">
        {options.map((option) => (
          <div key={option.value} className="custom-control custom-control-sm custom-checkbox mt-2 block">
            <input
              type="checkbox"
              className="custom-control-input form-control"
              checked={selectedValues.includes(option.value)}
              onChange={() => toggleOption(option.value)}
              id={`select-filter-${option.value}`}
            />
            <label className="custom-control-label" htmlFor={`select-filter-${option.value}`}>
              {" "}
              {option.label}
            </label>
          </div>
        ))}
      </div>
      <Button onClick={submit} className="btn btn-outline-light bg-violet-800 text-white mr-1 border-none px-4 w-100 mt-4 text-center hover:bg-slate-600 justify-center">
        <FunnelIcon className="w-3 h-3 mr-1" />
        Apply Filter
      </Button>
    </div>
  );
};

export default SelectFilter;
